import { createContext } from "react";
import { AccountInfo } from "@azure/msal-browser";

interface AuthContextProps {
  account?: AccountInfo | null;
  logout?: () => void;
  error: boolean;
}

export const AuthContext = createContext<AuthContextProps>({
  account: null,
  logout: undefined,
  error: false,
});
